import { OrgAdminConstants } from '../../../_constants';

const initialState = { addOrgTeamLoading: true, data: '', error: false };

export function addOrgTeamReducer(state = initialState, action) {
    
    switch (action.type) {
        case OrgAdminConstants.REQUEST_ADD_ORG_TEAM:
            return {
                addOrgTeamLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_ADD_ORG_TEAM:
            return {
                addOrgTeamLoading: false,
                data: action.getOrgTeam,
                error: false
            };
        case OrgAdminConstants.ADD_ORG_TEAM_ERROR:
            return {
                addOrgTeamLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/OrgTeam/addOrgTeam.reducer.js